/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { toSafeString } from '@/utils/toSafeString';

export const toUrlEncodedString = <T extends Record<string, unknown>>(obj: T): string => {
  const params = new URLSearchParams();
  Object.entries(obj).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      params.append(key, toSafeString(value));
    }
  });
  return params.toString();
};
